import { notification } from 'antd';

type NotificationType = 'success' | 'info' | 'warning' | 'error';

const openNotification = (
  type: NotificationType,
  title: string,
  description?: string,
  pauseOnHover: boolean = true
) => {
  notification[type]({
    message: title,  // Ant Design usa "message" no "title"
    description: description,
    duration: 3,  // Duración en segundos (opcional)
    showProgress: true,
    pauseOnHover,
  });
};

export default openNotification;
